import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useWindowSize} from '@primer/react-brand'
import {Fragment, useEffect, useMemo, useState} from 'react'

import {ChatContent} from './../ChatContent'
import {ChatContentV2, type ChatContentV2Props} from './../ChatContentV2/ChatContentV2'
import {CopilotHeader} from './../CopilotHeader'
import CopilotHeaderV2 from './../CopilotHeaderV2/CopilotHeaderV2'
import CopilotSidebar from './../CopilotSidebar/CopilotSidebar'
import {SignInDialog} from './../SignInDialog'
import Styles from './LoggedOutView.module.css'

export interface LoggedOutViewProps {
  initialModelId?: ChatContentV2Props['initialModelId']
  onIdeListItemClick: ChatContentV2Props['onIdeListItemClick']
}

export const defaultProps: Partial<LoggedOutViewProps> = {}

const LoggedOutView = (props: LoggedOutViewProps) => {
  const initializedProps: LoggedOutViewProps = {...defaultProps, ...props}
  const {initialModelId, onIdeListItemClick} = initializedProps

  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)
  const [isSignInDialogOpen, setIsSignInDialogOpen] = useState<boolean>(false)

  const isHyperspace2025LoggedOutBatch1 = isFeatureEnabled('hyperspace_2025_logged_out_batch_1')
  const isHyperspace2025LoggedOutBatch3 = isFeatureEnabled('hyperspace_2025_logged_out_batch_3')

  const {width} = useWindowSize()
  const isMobileView = useMemo(() => (width || 0) < 1024, [width])

  const isV2 = isHyperspace2025LoggedOutBatch1

  const HeaderComponent = useMemo(
    () =>
      isHyperspace2025LoggedOutBatch3 ? (
        <CopilotHeaderV2
          onSidebarToggle={() => setIsSidebarOpen(!isSidebarOpen)}
          onSignInClick={() => setIsSignInDialogOpen(true)}
        />
      ) : (
        <CopilotHeader />
      ),
    [isHyperspace2025LoggedOutBatch3, isSidebarOpen],
  )

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsSidebarOpen(!isMobileView)
  }, [isMobileView])

  const WrapperTag = isHyperspace2025LoggedOutBatch3 ? 'div' : Fragment
  const ContentTag = isHyperspace2025LoggedOutBatch3 ? 'div' : Fragment

  return (
    <WrapperTag {...(isHyperspace2025LoggedOutBatch3 ? {className: Styles['LoggedOutView']} : {})}>
      {isHyperspace2025LoggedOutBatch3 && (
        <CopilotSidebar isOpen={!isMobileView || isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      )}
      <ContentTag {...(isHyperspace2025LoggedOutBatch3 ? {className: Styles['LoggedOutView__content']} : {})}>
        {HeaderComponent}
        {isV2 ? (
          <ChatContentV2
            initialModelId={initialModelId}
            onSignInDialogChange={setIsSignInDialogOpen}
            onIdeListItemClick={onIdeListItemClick}
          />
        ) : (
          <ChatContent initialModelId={initialModelId} />
        )}

        {/* TODO: Implement flow for generated Copilot response using selected model */}
        {isSignInDialogOpen && <SignInDialog onClose={() => setIsSignInDialogOpen(false)} />}
      </ContentTag>
    </WrapperTag>
  )
}

export default LoggedOutView
